module.exports = Object.assign({},
  require('./lib'),
  require('./lib/TranslationProvider'),
  require('./lib/hooks'),
  require('./lib/withTranslate')
)
